var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100-vh"},[( !_vm.integration )?_c('StoresPagination'):_c('StoresIntegration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }